// import imgDefault from "public/logo.png";

type ImageSize = "x" | "s" | "m" | "l" | "2k" | "xl";

interface AppendImageParams {
  src?: string | null;
  size?: ImageSize;
}

export default function appendImageUrlFromAPI({
  src,
  size,
}: AppendImageParams): string {
  const IMAGE_SIZES: ImageSize[] = ["x", "s", "m", "l", "2k", "xl"];
  let _src = src ?? "";

  if (!src) return ""; // Trả về chuỗi rỗng để component tự dùng fallback

  if (size && !IMAGE_SIZES.includes(size)) {
    alert(`size: ${size} provided is invalid`);
  }

  if (src && !src.toLowerCase().startsWith("http")) {
    const serverUrl = process.env.server_url_report ?? "";
    const publicToken = process.env.public_token ?? "";
    const trustkey = process.env.trustkey ?? "";

    _src = `${serverUrl}${src}?access_token=${publicToken}&trustkey=${trustkey}${
      size ? `&size=${size}` : ""
    }`;
  }

  return _src;
}
